var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auditBox"},[_c('Form',{attrs:{"model":_vm.formData,"label-width":90}},[_c('FormItem',{attrs:{"label":"审核理由："}},[_c('Input',{attrs:{"type":"textarea","autosize":{minRows: 5}},model:{value:(_vm.formData.auditMsg),callback:function ($$v) {_vm.$set(_vm.formData, "auditMsg", $$v)},expression:"formData.auditMsg"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }